import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {PriceMismatchItem} from './dashboardTableTypes'
import {
  formatDashboardCurrency,
  renderDashboardDateTwoLine,
  renderDashboardLinkIcon,
  renderDashboardSku,
  renderDashboardTruncatedText,
} from './dashboardFormatters'

const columns: DashboardColumn<PriceMismatchItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {
    header: 'Channel',
    sortKey: 'channel',
    minWidth: 130,
    render: (item) => renderDashboardTruncatedText(item.channel),
  },
  {
    header: 'Type',
    sortKey: 'type',
    minWidth: 100,
    render: (item) => renderDashboardTruncatedText(item.type),
  },
  {header: 'Amazon Price', sortKey: 'amazon_price', render: (item) => formatDashboardCurrency(item.amazon_price)},
  {header: 'Channel Price', sortKey: 'channel_price', render: (item) => formatDashboardCurrency(item.channel_price)},
  {header: 'Difference', sortKey: 'difference', render: (item) => formatDashboardCurrency(item.difference), headerClassName: 'px-2'},
  {header: 'Changed At', sortKey: 'scraped_timestamp', width: 160, render: (item) => renderDashboardDateTwoLine(item.scraped_timestamp)},
  {header: 'Url', width: 120, render: (item) => renderDashboardLinkIcon(item.broken_link)},
  // {header: 'Broken Link', render: (item) => renderDashboardLink(item.broken_link)},
]

function PriceMismatchesShow() {
  return (
    <DashboardApiTableShow<PriceMismatchItem>
      endpoint='PriceMismatches'
      title='Price Mismatches'
      columns={columns}
    />
  )
}

export default PriceMismatchesShow
